import { render } from "./AnimatedNumberInput.vue?vue&type=template&id=13de3be4&scoped=true&ts=true"
import script from "./AnimatedNumberInput.vue?vue&type=script&lang=ts"
export * from "./AnimatedNumberInput.vue?vue&type=script&lang=ts"

import "./AnimatedNumberInput.vue?vue&type=style&index=0&id=13de3be4&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13de3be4"]])

export default __exports__